import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import type { ApiDropMentionedUser } from "@/generated/models/ApiDropMentionedUser";
import type { ApiMentionedWave } from "@/generated/models/ApiMentionedWave";
import WaveDropPart from "./WaveDropPart";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { ImageScale } from "@/helpers/image.helpers";
import useIsTouchDevice from "@/hooks/useIsTouchDevice";
interface WaveDropContentProps {
  readonly drop: ExtendedDrop;
  readonly activePartIndex: number;
  readonly setActivePartIndex: (index: number) => void;
  readonly onDropContentClick?: ((drop: ExtendedDrop) => void) | undefined;
  readonly onQuoteClick: (drop: ApiDrop) => void;
  readonly onLongPress: () => void;
  readonly setLongPressTriggered: (triggered: boolean) => void;
  readonly isEditing?: boolean | undefined;
  readonly isSaving?: boolean | undefined;
  readonly onSave?: ((newContent: string, mentions?: ApiDropMentionedUser[], mentionedWaves?: ApiMentionedWave[]) => void) | undefined;
  readonly onCancel?: (() => void) | undefined;
  readonly isCompetitionDrop?: boolean | undefined;
  readonly mediaImageScale?: ImageScale | undefined;
  readonly fullWidthMedia?: boolean | undefined;
  readonly hasTouch?: boolean | undefined;
  readonly onLinkCardActionsActiveChange?: ((href: string, active: boolean) => void) | undefined;
}
const WaveDropContent: React.FC<WaveDropContentProps> = t0 => {
  const $ = _c(17);
  const {
    drop,
    activePartIndex,
    setActivePartIndex,
    onDropContentClick,
    onQuoteClick,
    onLongPress,
    setLongPressTriggered,
    isEditing: t1,
    isSaving: t2,
    onSave,
    onCancel,
    isCompetitionDrop: t3,
    mediaImageScale: t4,
    fullWidthMedia: t5,
    hasTouch,
    onLinkCardActionsActiveChange
  } = t0;
  const isEditing = t1 === undefined ? false : t1;
  const isSaving = t2 === undefined ? false : t2;
  const isCompetitionDrop = t3 === undefined ? false : t3;
  const mediaImageScale = t4 === undefined ? ImageScale.AUTOx450 : t4;
  const fullWidthMedia = t5 === undefined ? false : t5;
  const isTouchDevice = useIsTouchDevice();
  const effectiveHasTouch = hasTouch ?? isTouchDevice;
  let t6;
  if ($[0] !== activePartIndex || $[1] !== drop || $[2] !== effectiveHasTouch || $[3] !== fullWidthMedia || $[4] !== isCompetitionDrop || $[5] !== isEditing || $[6] !== isSaving || $[7] !== mediaImageScale || $[8] !== onCancel || $[9] !== onDropContentClick || $[10] !== onLinkCardActionsActiveChange || $[11] !== onLongPress || $[12] !== onQuoteClick || $[13] !== onSave || $[14] !== setActivePartIndex || $[15] !== setLongPressTriggered) {
    t6 = <WaveDropPart drop={drop} activePartIndex={activePartIndex} setActivePartIndex={setActivePartIndex} onDropContentClick={onDropContentClick} onQuoteClick={onQuoteClick} onLongPress={onLongPress} setLongPressTriggered={setLongPressTriggered} isEditing={isEditing} isSaving={isSaving} onSave={onSave} onCancel={onCancel} isCompetitionDrop={isCompetitionDrop} mediaImageScale={mediaImageScale} fullWidthMedia={fullWidthMedia} hasTouch={effectiveHasTouch} onLinkCardActionsActiveChange={onLinkCardActionsActiveChange} />;
    $[0] = activePartIndex;
    $[1] = drop;
    $[2] = effectiveHasTouch;
    $[3] = fullWidthMedia;
    $[4] = isCompetitionDrop;
    $[5] = isEditing;
    $[6] = isSaving;
    $[7] = mediaImageScale;
    $[8] = onCancel;
    $[9] = onDropContentClick;
    $[10] = onLinkCardActionsActiveChange;
    $[11] = onLongPress;
    $[12] = onQuoteClick;
    $[13] = onSave;
    $[14] = setActivePartIndex;
    $[15] = setLongPressTriggered;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};
export default WaveDropContent;